import { useEffect, useState, useCallback } from "react";
import { useAppSelecter } from "../../../../hooks/storeHooks";
import { ObjectValues } from "../../../../pages/login";
import { getServerEnvironment } from ".";

/**
 * Custom hook to manage storeName data from localStorage.
 * Reacts to Redux refetchCopy state.
 */
const useLastMockMoved = () => {
  const [lastMock, setLastProceededData] = useState<any[]>([]);
const storeName=
        btoa(`lastProceed-${getServerEnvironment()}`)
  // 👇 Listen to global Redux flag for refetch trigger
  const refetchCopy = useAppSelecter(
    (state: ObjectValues) => state.userSlice?.refetchCopy
  );

  /** Decode and parse from base64 localStorage */
  const fetchlastMock = useCallback(() => {
    try {
      const stored = localStorage.getItem(storeName);
      if (stored) {
        const decoded = JSON.parse(decodeURIComponent(escape(atob(stored))));
        if (Array.isArray(decoded)) {
          setLastProceededData(decoded);
        } else {
          setLastProceededData([]);
        }
      } else {
        setLastProceededData([]);
      }
    } catch (err) {
      console.warn("Error reading copied data:", err);
      setLastProceededData([]);
    }
  }, []);

  /** Encode and save to localStorage */
  const updatelastMock = useCallback((newData: any[]) => {
    try {
      const encoded = btoa(
        unescape(encodeURIComponent(JSON.stringify(newData)))
      );
      localStorage.setItem(storeName, encoded);
      setLastProceededData(newData);
    } catch (err) {
      console.warn("Error saving copied data:", err);
    }
  }, []);

  /** Clear copied data */
  const clearlastMock = useCallback(() => {
    localStorage.removeItem(storeName);
    setLastProceededData([]);
  }, []);

  /** Initial load */
  useEffect(() => {
    fetchlastMock();
  }, [fetchlastMock]);

  /** Re-fetch when Redux refetchCopy changes */
  useEffect(() => {
    if (refetchCopy) {
      fetchlastMock();
    }
  }, [refetchCopy, fetchlastMock]);

  return {
    lastMock,
    setlastMock: updatelastMock,
    clearlastMock,
    refetchCopy,
  };
};

export default useLastMockMoved;
